import { useState } from 'react';
import { TextField, InputAdornment, IconButton } from 'components/mui';
import { VisibilityIcon, VisibilityOffIcon } from 'components/icons';
import { bool, func, shape, string } from 'prop-types';

/**
 * @component InputPwd
 * @param {Object} props
 * @param {string} [props.name]
 * @param {string} [props.label]
 * @param {string} [props.value]
 * @param {boolean} [props.required]
 * @param {Object} [props.valid]
 * @param {boolean} [props.valid.isErr]
 * @param {string} [props.valid.errMsg]
 * @param {Boolean} [props.valid.canSave]
 * @param {function} [props.onChange]
 * @returns {JSX.Element}
 */
function InputPwd(props) {
	const [showPwd, setShowPwd] = useState(false);

	return (
		<TextField
			data-tour={props['data-tour']}
			color="primary"
			size={props.size}
			fullWidth
			variant="outlined"
			InputLabelProps={{ shrink: true }}
			type={showPwd ? 'text' : 'password'}
			name={props.name}
			required={props.required}
			label={props.label}
			value={props.value}
			error={props.valid?.isErr}
			helperText={props.valid?.errMsg}
			onChange={props.onChange}
			autoComplete="new-password"
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton onClick={() => setShowPwd(!showPwd)}>
							{showPwd ? <VisibilityIcon /> : <VisibilityOffIcon />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
}

InputPwd.propsType = {
	name: string,
	label: string,
	required: bool,
	value: string,
	valid: shape({ isErr: bool, errMsg: string, canSave: bool }),
	onChange: func,
};

export default InputPwd;
